import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M14 8v8","key":"svg-2"}]]

const IconCircleNumber4 = createReactComponent('outline', 'circle-number-4', 'CircleNumber4', __iconNode);

export default IconCircleNumber4;